<script setup>
import { ref } from "vue"
import { api, post } from "../api"

const props = defineProps({ entityType: String, entityId: Number, links: { type: Array, default: () => [] } })
const emit = defineEmits(["refresh"])
const query = ref(""), results = ref([]), selected = ref(null), kind = ref("related"), searching = ref(false)

async function search() {
  searching.value = true
  results.value = (await api(`/entities?q=${encodeURIComponent(query.value)}`)).filter(item => !(item.type === props.entityType && item.id === props.entityId))
  searching.value = false
}
async function createLink() {
  if (!selected.value) return
  await post("/crm_links", { crm_link: { source_type: props.entityType, source_id: props.entityId, target_type: selected.value.type, target_id: selected.value.id, kind: kind.value } })
  query.value = ""; results.value = []; selected.value = null; emit("refresh")
}
async function removeLink(id) { await api(`/crm_links/${id}`, { method: "DELETE" }); emit("refresh") }
function path(entity) { return entity.type === "Partner" ? `/partners/${entity.id}` : `/tasks/${entity.id}` }
function relation(link) {
  if (link.kind === "related") return "Связана с"
  return link.direction === "outgoing" ? "Блокирует" : "Заблокирована"
}
</script>

<template><div class="entity-links">
  <div v-for="link in links" :key="link.id" class="entity-link-row"><span class="link-kind">{{ relation(link) }}</span><RouterLink :to="path(link.entity)">{{ link.entity.title }}</RouterLink><small>{{ link.entity.subtitle }}</small><button type="button" title="Удалить связь" @click="removeLink(link.id)">×</button></div>
  <div class="link-create"><select v-model="kind"><option value="related">Связана с</option><option value="blocks">Блокирует</option></select><div class="entity-search"><input v-model="query" placeholder="Найти партнёра или задачу" @input="search"><div v-if="results.length" class="entity-results"><button v-for="item in results" :key="`${item.type}-${item.id}`" type="button" @click="selected=item; query=item.title; results=[]"><strong>{{ item.title }}</strong><small>{{ item.subtitle }}</small></button></div></div><button type="button" :disabled="!selected || searching" @click="createLink">Связать</button></div>
</div></template>
